// extracted by mini-css-extract-plugin
export default {"container":"BidInfo_container__57Yb2","bidAmount":"BidInfo_bidAmount__4PJvn","bidMinimum":"BidInfo_bidMinimum__Z3s4i","timeRemaining":"BidInfo_timeRemaining__RSvR+"};